import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const CloudMigrationPage: React.FC = () => {
  return <ServicePageTemplate slug="cloud-migration" />;
};

export default CloudMigrationPage;
